// extracted by mini-css-extract-plugin
module.exports = {"banner":"Banner_banner__gV2Ma","info":"Banner_info__ouy_7","error":"Banner_error__1XiDl","fantasy":"Banner_fantasy__2Qcz_"};